import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient) {
  }

  sendNotificationsToAllUsers(data) {
    return this.http.post(environment.baseURL + 'notification/send-push/', data);
  }

}
